/* src/app/components/session-info/charge-percentage-info/charge-percentage-info.component.scss */
ion-text {
  white-space: nowrap;
}
/*# sourceMappingURL=charge-percentage-info.component.css.map */
